import { Fragment } from 'react';
import { Chip } from '@mui/material';
import { splitCitedText, type ChatCitation } from '@hv/shared';
import { BRAND } from '../theme';

export function CitationChip({ citation, onCite }: { citation: ChatCitation; onCite: (c: ChatCitation) => void }) {
  return (
    <Chip
      component="button"
      type="button"
      clickable
      size="small"
      variant="outlined"
      label={citation.label}
      disabled={!citation.available}
      onClick={() => onCite(citation)}
      aria-label={citation.available ? `Show source: ${citation.label}` : `Source no longer in the record: ${citation.label}`}
      data-testid="citation-chip"
      data-kind={citation.kind}
      sx={{ height: 20, mx: 0.25, fontSize: 11, fontWeight: 600, verticalAlign: 'text-bottom', color: BRAND.navy, borderColor: BRAND.line, bgcolor: '#fff', '& .MuiChip-label': { px: 0.75 } }}
    />
  );
}

export function CitedText({ text, citations, onCite }: { text: string; citations: ChatCitation[]; onCite: (c: ChatCitation) => void }) {
  const byTag = new Map(citations.map((c) => [c.tag, c]));
  return (
    <>
      {splitCitedText(text).map((segment, i) => {
        if (segment.type === 'text') return <Fragment key={i}>{segment.text}</Fragment>;
        const cited = segment.tags.map((t) => byTag.get(t.tag));
        if (cited.every((c) => !c)) return <Fragment key={i}>{segment.raw}</Fragment>;
        return (
          <Fragment key={i}>
            {segment.tags.map((t, j) => {
              const c = cited[j];
              return c ? <CitationChip key={j} citation={c} onCite={onCite} /> : <Fragment key={j}>[{t.tag}]</Fragment>;
            })}
          </Fragment>
        );
      })}
    </>
  );
}
